const styles = (theme) => ({
  root: {
    height: "100%",
    flexWrap: "nowrap",
  },
  list: {
    marginLeft: -16,
    marginRight: -16,
    height: "100%",
    padding: 0,
  },
  listContainer: {
    flex: 1,
    minHeight: 0,
    width: "100%",
  },
  input: {
    marginLeft: "0",
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  searchWrapper: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  rolTypeSection: {
    marginTop: 16,
    marginBottom: 4,
  },
  rolTypeToggle: {
    "& .MuiToggleButton-root": {
      padding: "4px 8px",
      fontSize: "0.75rem",
      lineHeight: 1.4,
      textTransform: "none",
      fontWeight: 500,
      color: theme.palette.text.secondary,
      backgroundColor: theme.palette.grey[100],
      borderColor: theme.palette.grey[300],
      "&:hover": {
        backgroundColor: theme.palette.grey[200],
      },
      "&.Mui-selected": {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        fontWeight: 600,
        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
        },
      },
    },
  },
});

export default styles;
